import React from 'react';
import PropTypes from 'prop-types';
import Highlighter from 'react-highlight-words';
import css from './TableCellDestination.css';
import Icon, { IconSizes } from '../foundations/Icon';
import OverflowingText from '../foundations/OverflowingText';
import NoLogoIcon from '../../resources/svg/no_logo.svg';

const highlighted = (text, searchText, className) => (
    <Highlighter
        highlightClassName={css.highlighted}
        searchWords={[searchText]}
        textToHighlight={text}
        autoEscape
        className={className}
    />
);

const TableCellDestination = ({
    tdStyle,
    containerStyle,
    searchText,
    value,
    schemaName,
    filterValue,
    uanId,
    imgSrc,
    agencyName,
    idLabel,
    filterLabel,
}) => {
    const hasSchema = Boolean(schemaName);
    const primaryText = hasSchema ? schemaName : value;

    return (
        <td style={tdStyle}>
            <div className={css.container} style={containerStyle}>
                <div className={css.image}>
                    {imgSrc ? <img alt="" className={css.logo} src={imgSrc} /> : <NoLogoIcon className={css.logo} />}
                </div>
                <div className={css.labels}>
                    {uanId ? <span className={css.idChip}>{`${idLabel} ${uanId}`}</span> : null}
                    <OverflowingText className={css.primary}>
                        {highlighted(primaryText || '', searchText)}
                    </OverflowingText>
                    {filterValue ? (
                        <div className={css.filterRow}>
                            <Icon name="filter" size={IconSizes.X_SMALL} className={css.filterIcon} />
                            <span className={css.filterLabel}>{filterLabel}</span>
                            <OverflowingText className={css.secondary}>
                                {highlighted(filterValue, searchText)}
                            </OverflowingText>
                        </div>
                    ) : null}
                    {hasSchema ? <div className={css.typeName}>{highlighted(value || '', searchText)}</div> : null}
                    {agencyName ? (
                        <div className={css.filterRow}>
                            <Icon name="briefcase" size={IconSizes.X_SMALL} className={css.filterIcon} />
                            <OverflowingText className={css.secondary}>
                                {highlighted(agencyName, searchText)}
                            </OverflowingText>
                        </div>
                    ) : null}
                </div>
            </div>
        </td>
    );
};

TableCellDestination.propTypes = {
    tdStyle: PropTypes.object,
    containerStyle: PropTypes.object,
    searchText: PropTypes.string,
    value: PropTypes.string,
    schemaName: PropTypes.string,
    filterValue: PropTypes.string,
    uanId: PropTypes.number,
    imgSrc: PropTypes.string,
    agencyName: PropTypes.string,
    idLabel: PropTypes.string,
    filterLabel: PropTypes.string,
};

export default TableCellDestination;
